"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const UserTime = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 17,
  viewBox: "0 0 16 17",
  fill: "none"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  className: "fill",
  d: "M7.667 2.707a2.333 2.333 0 100 4.667 2.333 2.333 0 000-4.667zM4 5.04a3.667 3.667 0 117.333 0A3.667 3.667 0 014 5.04zm8 4.667a2.333 2.333 0 100 4.667 2.333 2.333 0 000-4.667zM8.333 12.04a3.667 3.667 0 117.335 0 3.667 3.667 0 01-7.335 0zm-3-1.333a2.667 2.667 0 00-2.666 2.666h4.7v1.334H1.333v-1.334a4 4 0 014-4h2v1.334h-2zm7.334-.166v1.223l.942.943-.942.942-1.334-1.333v-1.775h1.334z",
  fill: "#1973E8"
}), /*#__PURE__*/_react.default.createElement("path", {
  className: "fill",
  d: "M7.667 2.707a2.333 2.333 0 100 4.667 2.333 2.333 0 000-4.667zM5.333 10.707a2.667 2.667 0 00-2.666 2.666h4.7l-.034-2.666h-2z",
  fill: "#1973E8"
}));
var _default = exports.default = UserTime;